import { createMuiStyles } from '../../utils/mui';

export const wishlistItemCardStyles = createMuiStyles({
  img: {
    display: 'block',
    objectFit: 'contain',
    width: {
      xs: '3rem',
      md: '5rem',
    },
    height: {
      xs: '3rem',
      md: '5rem',
    },
    borderRadius: '50%',
    bgcolor: 'common.white',
    border: 1,
    borderColor: 'divider',
  },
  card: {
    bgcolor: 'grey.50',
    borderRadius: '0.5rem',
    p: 3,
    display: 'block',
    height: 1,
    cursor: 'pointer',
    userSelect: 'none',
  },
});
